import {APP_ID, NgModule, provideZoneChangeDetection} from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { registerLocaleData } from '@angular/common';
import ptBr from '@angular/common/locales/pt';
registerLocaleData(ptBr);
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { OAuthModule, OAuthStorage } from 'angular-oauth2-oidc';
import { provideAnimations } from "@angular/platform-browser/animations";
import { ToastrModule } from 'ngx-toastr';
import { OrderPipe } from "ngx-order-pipe";
import { Interceptor } from './core/interceptors/interceptor.module';
import { SharedModule } from '@shared/shared.module';
import { CoreModule } from "./core/core.module";
import { LoginModule } from "@modules/public/login/login.module";
import { SelectProfileModule } from "@modules/commom/select-profile/select-profile.module";
import { TranslateModule } from "@ngx-translate/core";
import { MatDialogModule } from '@angular/material/dialog';
import { ShellPagesModule } from '@modules/commom/shell-pages/shell-pages.module';
import {provideHttpClient, withInterceptorsFromDi} from "@angular/common/http";

@NgModule({
  declarations: [
    AppComponent
  ],
  bootstrap: [AppComponent],
  imports: [
    BrowserModule,
    CoreModule,
    ShellPagesModule,
    AppRoutingModule,
    SharedModule,
    LoginModule,
    Interceptor,
    TranslateModule,
    ToastrModule.forRoot(),
    OAuthModule.forRoot({
      resourceServer: {
        sendAccessToken: false,
      },
    }),
    SelectProfileModule,
    TranslateModule.forRoot(),
    MatDialogModule,
  ],
  providers: [
    provideZoneChangeDetection(),
    provideAnimations(),
    OrderPipe,
    { provide: APP_ID, useValue: 'serverApp' },
    { provide: NgModule, useValue: "pt-PT" },
    { provide: OAuthStorage, useValue: localStorage },
    provideHttpClient(withInterceptorsFromDi())
  ],
})
export class AppModule {
}
